import styled from '@emotion/styled';
import { Stack, Flex } from '@pairy/pds-react';
import { theme } from '@pairy/styles';

export const StackWrapper = styled(Stack)`
  width: auto;
  height: 65px;

  flex: 0 0 0px;
  padding: 16px 0;
  background-color: transparent;

  opacity: 1;
  transition: opacity 0.15s ease-in-out;
`;

export const FlexCurrentPageTextWrapper = styled(Flex)`
  width: auto;
  min-width: 48px;

  height: 33px;
  padding: 8px;

  background: ${theme.colors.zinc_100};
  border-radius: 4px;
  color: ${theme.colors.black};
`;

export const Input = styled.input`
  width: 48px;
  height: 33px;
  padding: 4px 8px;
  appearance: textfield;
  background: ${theme.colors.zinc_100};
  color: ${theme.colors.black};
  outline: none;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
  }
`;
